export default function Marquee({ items, tone = "sun" }) {
  const row = items.map((i) => `${i}  ✦`).join("  ");
  const bg = tone === "sun" ? "bg-sun text-navy" : "bg-lime text-navy";
  return (
    <div className={`overflow-hidden ${bg} py-4 -rotate-1 scale-[1.02]`} data-testid="marquee-ribbon">
      <div className="marquee-track">
        {[0, 1].map((n) => (
          <span
            key={n}
            className="whitespace-nowrap px-6 font-display text-lg sm:text-xl font-bold uppercase tracking-wide"
          >
            {row}
          </span>
        ))}
      </div>
    </div>
  );
}
